import { formatKey } from "../../core/utils";
import isNil from "lodash/fp/isNil";

class Controller {
  constructor($stateParams, $injector, Lists) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.lists = Lists.all;
    this.Events = $injector.get("Events");
    this.Messages = $injector.get("Messages");
    this.Company = $injector.get("Company");
    this.sections = $injector.get("Sections").fleetSections;
    this.CompanyTransforms = $injector.get("CompanyTransforms");
    this.companyResourceId = $stateParams.id;
    this.onUpdateEvent = this.Events.getUpdateEvent("company");
    this.onUpdateExtraInfoEvent = this.Events.getUpdateEvent("extraInfo");
    this.successUpdateExtraInfoEvent = this.Events.successUpdateEvent(
      "extraInfo"
    );
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;

    this.companyDocumentsMetadata = [
      { title: "National ID", key: "national_id", holder: "owner" },
      {
        title: "Commercial Registration",
        key: "commercial_registration",
        holder: "documents",
      },
      {
        title: "Insurance Number",
        key: "insurance_number",
        holder: "documents",
      },
      { title: "Tax Number", key: "tax_number", holder: "documents" },
    ];

    this.innerListsResourceParams = {
      company: this.companyResourceId,
      isCityRequired: false,
    };
    this.captainsPaginateEvent = this.Events.getPaginateEvent(
      "companyCaptains"
    );
    this.busesPaginateEvent = this.Events.getPaginateEvent("companyBuses");

    this.addManager = this.addManager.bind(this);
    this.deleteManager = this.deleteManager.bind(this);
  }

  $onInit() {
    this.getCompany();

    this.Events.on(this.onUpdateEvent, this.onUpdate.bind(this));
    this.Events.on(
      this.onUpdateExtraInfoEvent,
      this.onUpdateExtraInfo.bind(this)
    );
  }

  getCompany() {
    this.Company.get(this.$stateParams.id).$promise.then(
      (response) => {
        this.company = this.CompanyTransforms.justify(response);
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  onUpdate(item) {
    if (!isNil(item.key)) {
      let value = isNil(item.value)
        ? item.name
          ? item.name._id
          : null
        : item.value;
      const { extraParams } = item;
      if (item.value === "true") value = true;
      if (item.value === "false") value = false;
      let updatedItem;
      if (isNil(extraParams)) {
        updatedItem = {
          [item.key]: value,
        };
      } else {
        updatedItem = {
          [extraParams]: {
            [item.key]: value,
          },
        };
      }

      this.Company.update(this.$stateParams.id, updatedItem).$promise.then(
        (response) => {
          this.company = this.CompanyTransforms.justify(response);
          this.Events.emit(
            this.successNotificationEvent,
            this.Messages.updateMessage("company", formatKey(item.key))
          );
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    }
  }

  onUpdateExtraInfo(options) {
    this.onUpdate({
      key: "extra_info",
      value: options.info,
    });
  }

  addManager({ name: managerName, _id: managerId }) {
    this.Company.addManagers(this.$stateParams.id, { managers: [managerId] })
      .$promise.then(() => {
        this.getCompany();
        this.Events.emit(this.successNotificationEvent, {
          message: `${managerName} is added successfully`,
        });
      })
      .catch((err) => this.Events.emit(this.errorNotificationEvent, err.data));
  }

  deleteManager({ name: managerName, _id: managerId }) {
    this.Company.deleteManagers(this.$stateParams.id, { managers: [managerId] })
      .$promise.then(() => {
        this.getCompany();
        this.Events.emit(this.successNotificationEvent, {
          message: `${managerName} is removed successfully`,
        });
      })
      .catch((err) => this.Events.emit(this.errorNotificationEvent, err.data));
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/company/company.controller.js